var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrencise({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.999,
    height: 36,
    viewBox: "0 0 35.999 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49445",
    "data-name": "Group 49445",
    transform: "translate(3311.749 6266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49444",
    "data-name": "Group 49444",
    transform: "translate(-3311.749 -6266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93671",
    "data-name": "Path 93671",
    d: "M70.669,57.812H59.741a1.93,1.93,0,0,0-1.929,1.929V70.669A1.93,1.93,0,0,0,59.741,72.6H70.669A1.93,1.93,0,0,0,72.6,70.669V59.741A1.93,1.93,0,0,0,70.669,57.812ZM63.6,59.1h3.214V60.7a1.607,1.607,0,1,1-3.214,0Zm-4.5.643a.643.643,0,0,1,.643-.643h2.571V60.7a1.607,1.607,0,0,1-3.214,0v-.964Zm7.714,11.571H63.6V68.58a.484.484,0,0,1,.482-.482h2.25a.484.484,0,0,1,.482.482Zm4.5-.643a.643.643,0,0,1-.643.643H68.1V68.58a1.769,1.769,0,0,0-1.768-1.768H64.08a1.769,1.769,0,0,0-1.768,1.768v2.732H59.741a.643.643,0,0,1-.643-.643V63.107a2.9,2.9,0,0,0,3.857-.608,2.855,2.855,0,0,0,4.5,0,2.9,2.9,0,0,0,3.857.608v7.562Zm0-9.964a1.607,1.607,0,0,1-3.214,0V59.1h2.571a.643.643,0,0,1,.643.643Z",
    transform: "translate(-36.599 -36.598)",
    fill: "#0c66e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93672",
    "data-name": "Path 93672",
    d: "M8.18,39.036H9.465v1.286a1.93,1.93,0,0,0,1.929,1.929H25.08a.643.643,0,1,0,0-1.286H11.394a.643.643,0,0,1-.643-.643c-.008-3.009.342-2.536-2.571-2.571a.645.645,0,0,1-.643-.643V8.179a.643.643,0,0,1,.643-.643H29.394a.643.643,0,0,1,.643.643V9.465h-13.5a.657.657,0,0,0-.455.188L9.653,16.081a.632.632,0,0,0-.138.209.652.652,0,0,0-.05.246V35.179a.643.643,0,0,0,1.286,0v-18h4.5A1.93,1.93,0,0,0,17.18,15.25v-4.5H32.608a.643.643,0,0,1,.643.643v13.5a.643.643,0,0,0,1.286,0v-13.5a1.93,1.93,0,0,0-1.929-1.929H31.323V8.179A1.93,1.93,0,0,0,29.394,6.25H8.18A1.93,1.93,0,0,0,6.251,8.179V37.107A1.93,1.93,0,0,0,8.18,39.035ZM15.894,15.25a.643.643,0,0,1-.643.643h-3.59l4.233-4.233Z",
    transform: "translate(-6.251 -6.25)",
    fill: "#0c66e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93673",
    "data-name": "Path 93673",
    d: "M40.518,42.049a.643.643,0,0,0-.643-.643H22.518a.643.643,0,1,0,0,1.286H39.875A.643.643,0,0,0,40.518,42.049Z",
    transform: "translate(-15.447 -26.942)",
    fill: "#0c66e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93674",
    "data-name": "Path 93674",
    d: "M34.089,50.781H22.517a.643.643,0,1,0,0,1.286H34.089A.643.643,0,0,0,34.089,50.781Z",
    transform: "translate(-15.447 -32.46)",
    fill: "#0c66e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93675",
    "data-name": "Path 93675",
    d: "M34.089,60.156H22.517a.643.643,0,1,0,0,1.286H34.089A.643.643,0,0,0,34.089,60.156Z",
    transform: "translate(-15.447 -37.978)",
    fill: "#0c66e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93676",
    "data-name": "Path 93676",
    d: "M34.089,69.531H22.517a.643.643,0,1,0,0,1.286H34.089A.643.643,0,0,0,34.089,69.531Z",
    transform: "translate(-15.447 -43.496)",
    fill: "#0c66e4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrencise);
export default __webpack_public_path__ + "static/media/frencise.512d0bd57b565d72814ba786b71e2443.svg";
export { ForwardRef as ReactComponent };